// extracted by mini-css-extract-plugin
export default {"overlay":"TermsDetail_overlay__o3wWd","modal":"TermsDetail_modal__jezGi","closeButton":"TermsDetail_closeButton__rVBJL","content":"TermsDetail_content__e3RyM"};